export default "__VITE_ASSET__c30560e6__"